const { get, post, put, del } = require("network/http/api")

export const getPlatform = (company_id, data) => {
  return get(`/store/platform`)
}
